/**
 * Errors not worth reporting to Sentry: browser-level fetch failures caused by
 * the user's connection (offline, aborted request, blocked by an extension).
 * Messages differ per browser: Chrome, Firefox, Safari.
 * @type {Array<String|RegExp>}
 */
export const SENTRY_IGNORE_ERRORS = [
  'Failed to fetch',
  'NetworkError when attempting to fetch resource',
  /^(\w+: )?Load failed$/,
  // Aborted requests (navigation away, connection reset): Firefox, Chrome
  'The operation was aborted',
  'The user aborted a request',
];
